/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { useLocation, NavLink, Link } from 'react-router-dom'
import * as ROUTES from '../../../../utils/constants/routes'
import Header2 from '../Header-2';
const Header = () => {
    const location = useLocation();
    if (location.pathname !== ROUTES.LANDING) return <Header2 />
    return (
        // <!-- Start nav bar -->
        <div className="navbar-area navbar-style-two">
            <div className="huruma-responsive-nav">
                <div className="container">
                    <div className="huruma-responsive-menu">
                        <div className="logo">
                            <Link to={ROUTES.LANDING} >
                                <img src="/assets/img/logo-child.png" className="white-logo" alt="logo" />
                                <img src="/assets/img/logo-child-2.png" className="black-logo" alt="Logo-2" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="huruma-nav">
                <div className="container">
                    <nav className="navbar navbar-expand-md navbar-light">
                            <Link to='/' className="navbar-brand">
                                <img src="/assets/img/logo-child.png" className="white-logo" alt="logo" />
                                <img src="/assets/img/logo-child-2.png" className="black-logo" alt="Logo-2" />
                            </Link>
                        <div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent" style={{ display: 'block', }}>
                            <ul className="navbar-nav">
                                {/* <!-- Home link --> */}
                                <li className="nav-item">
                                    <NavLink to={ROUTES.LANDING} className="nav-link active" >
                                        Home
                                    </NavLink>
                                </li>
                                {/* <!-- About link --> */}
                                <li className="nav-item">
                                    <NavLink to={ROUTES.ABOUT} className="nav-link" >
                                        About Us
                                    </NavLink>
                                </li>

                                {/* <!-- Causes link --> */}
                                <li className="nav-item">
                                    <NavLink to={ROUTES.CAUSES} className="nav-link">
                                        Causes
                                    
                                    </NavLink>
                                </li>

                                {/* <!-- pages link --> */}
                                <li className="nav-item">
                                    <NavLink to={ROUTES.GALLERY} className="nav-link">
                                        Gallery
                                    </NavLink>
                                     </li>
                                {/* <!-- Blog link --> */}
                                <li className="nav-item">
                                    <NavLink to={ROUTES.BLOG} className="nav-link">
                                        Blog
                                    </NavLink>
                                    </li>
                                {/* <!-- Contact link --> */}
                                <li className="nav-item">
                                    <NavLink to={ROUTES.CONTACT} className="nav-link">
                                        Contact
                                    </NavLink>

                                </li>
                            </ul>

                            {/* <!-- other options --> */}
                            <div className="others-options">
                                <div className="dropdown language-switcher d-inline-block">
                                    <button className="dropdown-toggle" type="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <img src="/assets/img/flag/france-flag.jpg" className="shadow" alt="Shadow" />
                                        <span>
                                            Eng
                                            <i className="bx bx-chevron-down"></i>
                                        </span>
                                    </button>
                                    <div className="dropdown-menu">
                                        <a href="_" className="dropdown-item d-flex align-items-center">
                                            <img src="/assets/img/flag/germany-flag.jpg" className="shadow-sm" alt="flag" />
                                            <span>Ger</span>
                                        </a>
                                        <a href="_" className="dropdown-item d-flex align-items-center">
                                            <img src="/assets/img/flag/italy-flag.jpg" className="shadow-sm" alt="flag" />
                                            <span>Fre</span>
                                        </a>
                                        <a href="_" className="dropdown-item d-flex align-items-center">
                                            <img src="/assets/img/flag/spain-flag.jpg" className="shadow-sm" alt="flag" />
                                            <span>Spa</span>
                                        </a>
                                        <a href="_" className="dropdown-item d-flex align-items-center">
                                            <img src="/assets/img/flag/russia-flag.jpg" className="shadow-sm" alt="flag" />
                                            <span>Rus</span>
                                        </a>
                                        <a href="_" className="dropdown-item d-flex align-items-center">
                                            <img src="/assets/img/flag/us-flag.jpg" className="shadow-sm" alt="flag" />
                                            <span>Ita</span>
                                        </a>
                                    </div>
                                </div>

                                {/* <!-- option --> */}
                                <div className="option-item">
                                    <i className="search-btn bx bx-search"></i>
                                    <i className="close-btn bx bx-x"></i>
                                    <div className="search-overlay search-popup">
                                        <div className="search-box">
                                            <form className="search-form">
                                                <input className="search-input" name="search" placeholder="Search" type="text" />

                                                <button className="search-button" type="submit">
                                                    <i className="bx bx-search"></i>
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div className="burger-menu">
                                    <i className="menu-icon flaticon-menu"></i>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </div>

    );
}

export default Header;
